import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress, Grid } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, ShopActions, NotificationActions } from '../../../store';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import InputIcon from '@material-ui/icons/Input';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const shopsSelector = (state) => state.Shops;
const IdentitySelector = (state) => state.Identity;

const ShopList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(shopsSelector);
    const { token, userData, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    // 一覧のフィルタリング要素の復元用
    var merchantName = props.merchantName;  // 加盟店名
    var shopName = props.shopName;          // 店舗名
    var shopType = props.shopType;          // 店舗タイプ
    var status = props.status;              // ステータス

    const listDefinition = {
        columns: [
            {
                // 加盟店名
                title: <FormattedMessage id="Shop.MerchantName" />,
                field: 'merchant_name',
                filtering: true,
                defaultFilter: props.merchantName,
            },
            {
                // 店舗名
                title: <FormattedMessage id="Shop.Name" />,
                field: 'shop_name',
                filtering: true,
                defaultFilter: props.shopName,
            },
            {
                title: <FormattedMessage id="Shop.ShopType" />,
                field: 'shop_type',
                lookup: {
                    1: "固定",
                    2: "可動式"
                },
                filtering: true,
                defaultFilter: props.shopType,
            },
            {
                title: <FormattedMessage id="Shop.Status" />,
                field: 'status',
                lookup: {
                    0: "無効",
                    1: "有効"
                },
                filtering: true,
                defaultFilter: props.status,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {
        merchantName = '';
        shopName = '';
        shopType = '';
        status = '';

        // フィルタリング内容を退避
        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'merchant_name') {
                    merchantName = filter[i].value;
                } else if (filter[i].column.field == 'shop_name') {
                    shopName = filter[i].value;
                } else if (filter[i].column.field == 'shop_type') {
                    shopType = filter[i].value;
                } else if (filter[i].column.field == 'status') {
                    status = filter[i].value;
                }
            };
        }
    }

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        // 初期レンダリングの時のみ店舗一覧を取得
        if (props.refresh == null || props.refresh == true) {
            // storeに店舗リストを要求
            // 店舗一覧を取得
            shopActions.listShops(token, props.merchantId)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });        }

    }, []);

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel(merchantName, shopName, shopType, status);
    }

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        props.onDetail(data, merchantName, shopName, shopType, status);
    }

    /**
     * 
     * 新規ボタン押下時の処理
     * 
     */
    const onCreateClick = () => {
        props.onCreate(merchantName, shopName, shopType, status);
    }

    /**
     * 
     * 一括登録ボタン押下時の処理
     * 
     */
    const onBulkRegistClick = () => {
        props.onBulkRegist(merchantName, shopName, shopType, status);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    var backButton = <div></div>;
    if (!(userData.role == 4 || userData.role == 5)) {
        backButton =
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => onBackClick()}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>;
    }

    var bulkButton = <div></div>;
    if (permissions != null && permissions != undefined && permissions.fid5_3 != null && permissions.fid5_4 != null) {
        if ((permissions.fid5_3.value.value & 2) == 2 && (permissions.fid5_4.value.value & 2) == 2) {
            bulkButton =
                <Button onClick={() => onBulkRegistClick()} variant="contained" color="secondary" size="medium" startIcon={<InputIcon />} >
                    <FormattedMessage id="Shop.BulkRegistration" />
                </Button>;
        }
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <MaterialTable
                title={<Typography component="h1" variant="inherit">{<FormattedMessage id="Shop.Title" />}</Typography>}
                onFilterChange={(filter) => onChangeFilter(filter)}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（新規追加ボタン、詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            if (permissions != null && permissions != undefined && permissions.fid5_3 != null && (permissions.fid5_3.value.value & 2) == 2) {
                                return (
                                    <div>
                                        {bulkButton}
                                        <Button onClick={() => onCreateClick()} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />} style={{ margin: 10 }}>
                                            <FormattedMessage id="Shop.Create" />
                                        </Button>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div></div>
                                )
                            }
                        }
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

            {backButton}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(ShopList);
